import React, { useCallback, useEffect } from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { MenuItem, designSystem } from '@yola/ws-ui';
import mainMenu from 'src/js/modules/main-menu';
import SubMenuGroup from './sub-menu-group';
import getVisibilityStatus from '../../selectors/get-visibility-status';

const { Icon, Popover, PopoverContent, PopoverTrigger, Paragraph } = designSystem;

const POPOVER_WIDTH = 250;

// eslint-disable-next-line yola/react/prop-types
const MenuItemComponent = ({ href, disabled, target, type, heading, id, icon, handleClick }) => (
  <MenuItem
    onClick={handleClick}
    href={href}
    disabled={disabled}
    target={target}
    type={type}
    className={id ? `ws-menu-item-${id}` : ''}
  >
    {!href ? (
      <span className="ws-menu-item--container">
        {icon && <Icon className="ws-menu-item--icon" {...icon} />}
        <span className="ws-menu-item__heading">{heading}</span>
      </span>
    ) : (
      <>
        {icon && <Icon className="ws-menu-item--icon" {...icon} />}
        {heading}
      </>
    )}
  </MenuItem>
);

function NavMenuItem({ item }) {
  const close = useCallback(() => mainMenu.operations.hide(), []);
  const { onClick, popoverProps, disabled, subMenu } = item;
  const hasPopover = !!(popoverProps?.description && popoverProps?.title);
  const isMenuOpen = useSelector(getVisibilityStatus);

  const handleClick = useCallback(
    (event) => {
      if (!disabled) {
        close();
      }

      if (onClick) {
        onClick(event);
      }
    },
    [disabled, close, onClick]
  );

  useEffect(() => {
    if (!isMenuOpen && hasPopover) {
      Popover.hide();
    }
  }, [isMenuOpen, hasPopover]);

  if (subMenu) {
    return <SubMenuGroup item={item.subMenu} beforeItemClick={close} />;
  }

  if (hasPopover) {
    return (
      <Popover
        width={POPOVER_WIDTH}
        placement="right-center"
        appearance="dark"
        title={popoverProps.title}
      >
        <PopoverTrigger>
          <MenuItemComponent {...item} handleClick={handleClick} />
        </PopoverTrigger>
        <PopoverContent>
          <Paragraph align="left" appearance="low-emphasis" size="medium">
            {popoverProps.description}
          </Paragraph>
        </PopoverContent>
      </Popover>
    );
  }

  return <MenuItemComponent {...item} handleClick={handleClick} />;
}

NavMenuItem.propTypes = {
  item: PropTypes.object.isRequired,
};

export default NavMenuItem;
